module.exports = __webpack_public_path__ + "static/img/stay-option-icon-parking.ab7b3b53.svg";